import { SVGProps } from 'react';

const INRToggleIcon = ({
  width = 24,
  height = 24,
  stopColor = '#8AD137',
}: SVGProps<SVGAElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-palette="INRToggleIcon">
    <circle cx="8" cy="8" r="8" fill="#00A64F" />
    <circle cx="8" cy="8" r="8" fill="url(#paint0_radial_3707_70)" />
    <path
      d="M8.22368 11.4978L6.42368 8.3578V7.6178H7.02368C7.26368 7.6178 7.47368 7.58447 7.65368 7.5178C7.84035 7.44447 7.99368 7.34114 8.11368 7.2078C8.24035 7.07447 8.32702 6.91447 8.37368 6.7278H6.42368V5.9878H8.36368C8.32368 5.81447 8.25368 5.66114 8.15368 5.5278C8.06035 5.39447 7.93368 5.29114 7.77368 5.2178C7.62035 5.1378 7.43368 5.0978 7.21368 5.0978H6.42368V4.3578H10.9337V5.0978H9.36368C9.47702 5.22447 9.57035 5.36114 9.64368 5.5078C9.72368 5.65447 9.77702 5.81447 9.80368 5.9878H10.9337V6.7278H9.82368C9.75702 7.22114 9.56702 7.6078 9.25368 7.8878C8.94035 8.16114 8.53702 8.3478 8.04368 8.4478L10.0037 11.4978H8.22368Z"
      fill="#262832"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3707_70"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.4181 2.80525) scale(10.627)"
      >
        <stop offset="0.0983633" stopColor={stopColor} />
        <stop offset="1" stopColor={stopColor} stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export default INRToggleIcon;
